module.exports = `${require.publicPath}ckeditor5.ecbc4a74.scss`;